import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	width: 100vw;
	height: 100vh;

	background-color: #e0e0e0;
	background-image: url('/company-logo.jpg');
	background-repeat: no-repeat;
	background-size: cover;

	.login-password {
		& > button {
			top: 10px;
		}
	}
	.login-password-new {
		& > button {
			top: 5px;
		}
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 350px;
	width: 450px;
	min-height: 480px;
	height: auto;
	padding: 4rem;

	background-color: #fff;

	border-radius: 8px;

	#authentication-form {
		display: flex;
		align-items: center;
		flex-direction: column;

		row-gap: 1rem;

		.btn-signin-dark {
			max-width: 202px;

			margin-top: 2.4rem;

			background-color: #8dc63f;
			border-color: #8dc63f;

			&:hover {
				filter: brightness(0.94);
			}
		}
	}
`;

export const WrapperHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		width: auto;
		height: 93px;
	}
`;
